<template>
  <div class="tsc-inline clearfix" v-if="timeslotCollection">
    <div class="colorbox" style="float: left" :style="{ backgroundColor: timeslotCollection.color}"></div>
    <div style="margin-left: 35px; margin-top: 0">
      <font-awesome-icon icon="wrench" class="taskicon" @click.prevent="onEdit" />
      <span style="font-size: 16pt; line-height: 1em">{{timeslotCollection.name}}</span>
      <br>
      Type: {{timeslotCollection.type}}
      <!--
      <font-awesome-icon icon="trash-alt" class="taskicon" @click.prevent="onRemove" v-if="showDelete" />
      -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tsc_id: {
      default: null
    },
    showDelete: {
      default: false
    }
  },
  computed: {
    timeslotCollection() {
      return this.tsc_id
        ? this.$models.timeslotCollection.getNode( this.tsc_id )
        : null;
    }
  },
  methods: {
    onRemove() {
      console.log("todo");
    },

    onEdit() {
      this.$root.showUpdateModal('timeslot-collection', {
        timeslotCollectionId: this.tsc_id
      })
    }
  }
}
</script>

<style>
.tsc-inline {
  border: 1px solid #dcdfe6;
  padding: 5px;
  margin: 5px 0;
}
.tsc-inline .taskicon {
  float: right;
  margin: 5px;
  cursor: pointer;
}
</style>
